<div class="page-breadcrumb" *ngIf="read==true || delete==true ">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">User Account Management</h4>
        </div>

    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-sm-12 col-md-8">
                                    <label>All User Accounts</label>
                                </div>
                                
                                <div class="col-md-11">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" *ngIf="export==true">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </diV>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width:895px">
                                <div class="container-fluid" style="color: black">
                                   
                                    <input type="radio" id="companyname" name="gender" [(ngModel)]="filterValueSelected" value="cn" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Company Name &nbsp;&nbsp;
                                    <input type="radio" id="mobilenumber" name="gender" [(ngModel)]="filterValueSelected" value="umn" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> User Mobile Number &nbsp;&nbsp;
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected" value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Email Id &nbsp;&nbsp;

                                </div>
                                <div style="margin-left: 820px">
                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>
                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput  [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                       
                                        
                                        <ng-container matColumnDef="CompanyName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
                                            <td *matCellDef="let row"> {{row.CompanyName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="CompanySize">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Size</th>
                                            <td *matCellDef="let row"> {{row.CompanySize}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="Address">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                                            <td *matCellDef="let row">  {{row.Address}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="UserMobileNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User Mobile Number
                                            </th>
                                            <td *matCellDef="let row">{{row.UserMobileNumber}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="EmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Id</th>
                                            <td *matCellDef="let row">{{row.EmailId}}</td>
                                        </ng-container> 
                                        <ng-container matColumnDef="AccountStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Status</th>
                                            <td *matCellDef="let row">{{row.AccountStatus}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> User Account Status</th>
                                            <td *matCellDef="let row">  <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span></td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Creation</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true && write !=true && delete !=true"
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    don't have permissions to Edit/Delete</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf="delete==true || write==true">
                                                    <li class="list-group-item  friend-list mb-2">
                                                       
                                                        <div class="dropdown show float-right list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                id="userDropdown" style="margin-right: 140px;"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">

                                                                <button class="dropdown-item" *ngIf="delete==true"
                                                                    (click)="deleteuserAccount(row._id)">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <mat-slide-toggle (change)="onChange($event,row._id)"
                                                                    [checked]="row.status">
                                                                    <span *ngIf="row.status==false">
                                                                        In Active</span>
                                                                    <span *ngIf="row.status==true">
                                                                        Active</span>
                                                                </mat-slide-toggle>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>
                                        <!-- <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                        <td *matCellDef="let row">
                                          <mat-slide-toggle (change)="onChange($event,row.id)" class="example-margin" [color]="color" [checked]="row.status">
                                          </mat-slide-toggle>
                                        </td>
                                      </ng-container> -->
                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->